import {action, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import {default as handleErrorToast} from "../../../components/toast/ErrorToast";
import {default as handleSuccessToast} from "../../../components/toast/SuccessToast";
import CustomerContactForm from "../../../domain/CustomerContactForm";
import CustomerOnboardingPanelFeature from "./CustomerOnboardingPanelFeature";

export default class CustomerContactPanelFeature extends CustomerOnboardingPanelFeature {

    constructor(application, generalFeature) {
        super(application, generalFeature);
        this._customerContactForm = null;

        makeObservable(this, {
            _customerContactForm: observable,
            editCustomerContact: action,
        })
    }

    async load() {
        this.createCustomerContactForm();
        this.finishLoading();
    }

    createCustomerContactForm() {
        this._customerContactForm = CustomerContactForm.newFor(this.customerOnboarding().request.contactData, this, this.customerOnboarding().configuration);
    }

    async editCustomerContact() {
        const canSave = this._customerContactForm && this._customerContactForm.isValid;
        if (canSave) {
            const responseHandler = new ApiResponseHandler({
                handlesSuccess: async (response) => {
                    await this.customerOnboardingHasChanged()
                    this.createCustomerContactForm()
                    handleSuccessToast("Datos guardados correctamente.");
                },
                handlesError: (response) => {
                    handleErrorToast("No se pudieron guardar los datos.");
                }
            });
            return this._application.apiClient().editContactData(this.customerOnboarding().request.taxpayerIdentificationNumber,
                this._customerContactForm.values, responseHandler);
        }
    }

    createForm(){
        return this.createCustomerContactForm()
    }

    get form() {
        return this._customerContactForm;
    }
}
